import React, { Component } from 'react';
import './Signup.css';
import services from '../services'
import coords from '../coords'

declare var google;

class Signup extends Component {


   constructor(props) {
     super(props)
     this.state = {
       first_name: '',
       last_name: '',
       phone: '',
       email: '',
       address: {},
       errors: [],
       tag: '',
       loading: false
     }

     this.changeName = this.changeName.bind(this);
     this.changeLastName = this.changeLastName.bind(this);
     this.changePhone = this.changePhone.bind(this);
     this.changeEmail = this.changeEmail.bind(this);
     this.createUser = this.createUser.bind(this);
     this.changeDescription = this.changeDescription.bind(this);
     this.initAutoComplete = this.initAutoComplete.bind(this)
     this.setTag = this.setTag.bind(this)
     this.changeTag = this.changeTag.bind(this)

   }

   componentDidMount() {
     this.initAutoComplete()
     this.getCurrentPosition()
   }

   initAutoComplete() {
     let autocomplete = new google.maps.places.Autocomplete(this.refs.address, {
       types: ["address"],
       componentRestrictions: {country: "mx"}
     });
     let circle = new google.maps.Circle({
       center: {lat: coords[this.props.city].lat , lng: coords[this.props.city].lng },
       radius: 30,
     });
     autocomplete.setBounds(circle.getBounds());
     autocomplete.addListener("place_changed", () => {
        let place = autocomplete.getPlace();
        let address = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          address: place.formatted_address,
          tag: 'Otro',
          address_description: this.state.address.description
        }
        localStorage.setItem('address', JSON.stringify(address))
        this.setState({
          address
        })
     })
   }


   getCurrentPosition() {
   if ("geolocation" in navigator) {
     this.refs.address.value = "Cargando tu ubicacion...";
     navigator.geolocation.getCurrentPosition(
      (success) => {
         this.geocodePosition({lat: success.coords.latitude, lng: success.coords.longitude})
       },
       (error) => {
          this.refs.address.value = " ";
       } , {timeout: 10000})
     }
  }

  geocodePosition(position) {
     let geocoder = new google.maps.Geocoder();
     geocoder.geocode({
       latLng: position
     }, (responses) => {
       if (responses && responses.length > 0) {
         this.refs.address.value = responses[0].formatted_address;
         let address = {
           lat: position.lat,
           lng: position.lng,
           address: responses[0].formatted_address,
           tag: 'Otro',
           address_description: this.state.address.description
         }
         this.setState({
           address,
         })
       }
     });
   }

   changeName(event) {
     this.setState({
       first_name: event.target.value
     })
   }

   changeLastName(event) {
     this.setState({
       last_name: event.target.value
     })
   }

   changePhone(event) {
     this.setState({
       phone: event.target.value
     })
   }

   changeEmail(event) {
     this.setState({
       email: event.target.value
     })
   }

   changeDescription(event) {
     let address = this.state.address
     address.address_description = event.target.value
     this.setState({
       address
     })
   }

  async createUser(event) {
     event.preventDefault();
     this.setState({
       loading: true
     })
     let response = await services.createUser(this.state)
     if(response.errors) {
       this.setState({
         errors: response.errors,
         loading: false
       })
     } else {
       let address = this.state.address;
       address.user_id = response.id;
       localStorage.setItem('user', JSON.stringify(response))
       this.setState({ address } , () => {
         this.addAddress();
       })
     }
   }

   async addAddress() {
       let response = await services.addAddress(this.state.address);
       if(response.success) {
         response = response.data;
         let res = await services.getAddresses(this.state.address.user_id);
          res = res.data;
         if(res.addresses) {
           localStorage.setItem('newAddress', JSON.stringify(res.addresses[0]))
           this.setState({
             loading: false
           })
           this.props.register(true)
         }
       }
   }

   setTag(tag) {
     let address = this.state.address
     address.tag = tag;
     this.setState({
       address,
       tag: ''
     })
   }

   changeTag(event) {
     let address = this.state.address
     address.tag = event.target.value;
     this.setState({
       address,
       tag: event.target.value
     })
   }


render() {
  let errors = []

  for(let errorIndex in this.state.errors) {
    errors.push(  <p className="error center"> {this.state.errors[errorIndex]} </p>  )
  }
  return (
    <form className="register center" onSubmit={this.createUser}>
    <div className="row container">
    <div className="col s12">
        <div className='input-field'>
            <input type="text"  id="first_name" value={this.state.first_name} onChange={this.changeName}   required />
            <label htmlFor="first_name">Nombre</label>
        </div>
      <div className='input-field'>
           <input type="text" id="last_name" value={this.state.last_name} onChange={this.changeLastName}   aria-describedby="exampleHelpText" required />
         <label  htmlFor="last_name">Apellido</label>
      </div>
      <div className='input-field'>
          <input type="number"  id="phone" value={this.state.phone}  onChange={this.changePhone}  required />
          <label  htmlFor="phone">Celular</label>
      </div>
      <div className='input-field'>
          <input type="text" id="email" value={this.state.email} onChange={this.changeEmail} required />
          <label  htmlFor="email">Email</label>
      </div>
      <span>Agrega tu dirección </span>
      <div className='input-field'>
          <input ref="address" type="text" id="address" placeholder="Escribe aqui tu dirección Ej: Paseo de la Reforma 99" required />
          <label  htmlFor="address">Dirección</label>
      </div>
      <div className='input-field'>
          <input  type="text" id="description"  value={this.state.address.description} placeholder="Piso/Oficina/Apto/Dpto Ej: Oficina 304"  onChange={this.changeDescription}   required />
          <label  htmlFor="description">Descripción</label>
      </div>
      <label className="left">Tag</label>
      <div className="row">
      <div className="col s12 m9">
         <div className="tags">
            <div className="chip" onClick={()=> this.setTag('casa')}>
               <i className={"material-icons circle " + (this.state.address.tag === 'casa' ? 'teal' : ' ')}>home</i>
               Casa
            </div>
            <div className="chip" onClick={()=> this.setTag('oficina')}>
               <i className={"material-icons circle " + (this.state.address.tag === 'oficina' ? 'teal' : ' ')}>local_cafe</i>
               Oficina
            </div>
            <div className="chip" onClick={()=> this.setTag('novi@')}>
               <i className={"material-icons circle " + (this.state.address.tag === 'novi@' ? 'teal' : ' ')}>supervisor_account</i>
               Novi@
            </div>
        </div>
    </div>
      <div className="col m2 s12">
        <div className='input-field'>
            <input  value={this.state.tag} onChange={this.changeTag} type="text" id="tag" />
            <label  htmlFor="tag">Otro</label>
        </div>
      </div>
      </div>
      </div>

      <div className="col s12">
          {errors}
    { !this.state.loading &&  <div className='buttons'>
          <button className="success btn" type="submit" value="Submit">Continuar</button>
        </div>
    }
    {this.state.loading &&
      <div className="preloader-wrapper small active">
         <div className="spinner-layer spinner-teal-only">
           <div className="circle-clipper left">
             <div className="circle"></div>
           </div><div className="gap-patch">
             <div className="circle"></div>
           </div><div className="circle-clipper right">
             <div className="circle"></div>
           </div>
         </div>
       </div>
    }
      </div>
    </div>
  </form>
)
}



}


export default Signup



// WEBPACK FOOTER //
// ./src/signup/Signup.js